import React from "react"

import {useIntl} from "@irati/utils/lang"
import Alert, {AlertTypes} from "@irati/ui/src/Alert"

interface Props {
  maxItems: number
}

const MaxItemsReached: React.FC<Props> = ({maxItems}) => {
  const {formatMessage} = useIntl()
  return (
    <Alert
      type={AlertTypes.warning}
      title={formatMessage({id: "perks.components.productForms.maxItemsReachedV2"}, {value: maxItems})}
      nonDismissable
    />
  )
}

export default MaxItemsReached
